import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const Field = ({ type, icon, name, className, valid = true, ...other }) => (
	<label
		htmlFor={name}
		className={classnames(styles.field, className, {
			[styles.file]: type === 'file',
			[styles.icon]: icon !== '',
			[styles.invalid]: !valid,
		})}
	>
		{icon && <i className="material-icons">{icon}</i>}
		<input type={type} name={name} {...other} />
	</label>
);

export default Field;



// WEBPACK FOOTER //
// ./src/components/atoms/Field/index.js